import { Select } from '@maxtropy/components';
import { apiV2LeanEnergyFlowAnalysisConfigDetailPost } from '@maxtropy/device-customer-apis-v2';
import { Col, Row, Form, FormInstance } from 'antd';
import { Key, useEffect, useState } from 'react';

interface LevelConfigModalProps {
  disabled?: boolean;
  energyUnitGroupId?: Key;
  updateFn?: () => void;
  value?: { fromLevel?: number; toLevel?: number }; // 新增 value prop
  onChange?: (value: { fromLevel: number | undefined; toLevel: number | undefined }) => void; // 新增 onChange prop
  onLoadingChange?: (loading: boolean) => void;
}

const LevelConfigModal: React.FC<LevelConfigModalProps> = props => {
  const { disabled, energyUnitGroupId, value, onChange, onLoadingChange } = props;
  const [levelOptions, setLevelOptions] = useState<any>();

  useEffect(() => {
    if (!energyUnitGroupId) {
      setLevelOptions([]);
      onChange?.({ fromLevel: undefined, toLevel: undefined });
      return;
    }
    onLoadingChange?.(true);
    apiV2LeanEnergyFlowAnalysisConfigDetailPost({ energyGroupId: energyUnitGroupId as number })
      .then(res => {
        const list = Array.from({ length: res.maxLevel ?? 0 }, (_, i) => ({ value: i + 1, label: `${i + 1}级` }));
        const fromLevel = value?.fromLevel ?? 1;
        const toLevel = Math.min(value?.toLevel ?? 3, res.maxLevel ?? 1);
        setLevelOptions(list);
        // 触发 onChange 以更新父级
        onChange?.({ fromLevel, toLevel });
      })
      .catch(() => undefined)
      .finally(() => onLoadingChange?.(false));
  }, [energyUnitGroupId]);

  const handleFromChange = (val: number) => {
    onChange?.({ fromLevel: val, toLevel: value?.toLevel ?? 1 });
  };

  const handleToChange = (val: number) => {
    onChange?.({ fromLevel: value?.fromLevel ?? 1, toLevel: val });
  };

  return (
    <Row>
      <Col>
        <Select
          disabled={disabled}
          options={levelOptions}
          placeholder="请选择"
          value={value?.fromLevel}
          onChange={handleFromChange}
          style={{ width: '120px' }}
        />
      </Col>
      <div style={{ textAlign: 'center', margin: '0 8px' }}>～</div>
      <Col>
        <Select
          disabled={disabled}
          options={levelOptions}
          placeholder="请选择"
          value={value?.toLevel}
          onChange={handleToChange}
          style={{ width: '120px' }}
        />
      </Col>
    </Row>
  );
};

export default LevelConfigModal;
